import axios from "axios";

const BACKEND_URL = process.env.REACT_APP_BACKEND_URL;
export const API = `${BACKEND_URL}/api`;

const client = axios.create({ baseURL: API });

export const TOKEN_KEY = "sx_token";
export const getToken = () => localStorage.getItem(TOKEN_KEY);
export const setToken = (t) => (t ? localStorage.setItem(TOKEN_KEY, t) : localStorage.removeItem(TOKEN_KEY));

client.interceptors.request.use((config) => {
  const t = getToken();
  if (t) config.headers.Authorization = `Bearer ${t}`;
  return config;
});

// ---- Auth ----
export const authStatus = () => client.get("/auth/status").then((r) => r.data);
export const authSetup = (payload) => client.post("/auth/setup", payload).then((r) => r.data);
export const totpConfirm = (payload) => client.post("/auth/totp/confirm", payload).then((r) => r.data);
export const authLogin = (payload) => client.post("/auth/login", payload).then((r) => r.data);
export const authLoginVerify = (payload) => client.post("/auth/login/verify", payload).then((r) => r.data);
export const authMe = () => client.get("/auth/me").then((r) => r.data);
export const authLogout = () => client.post("/auth/logout").then((r) => r.data);
export const createInvite = (payload) => client.post("/auth/invites", payload).then((r) => r.data);
export const listInvites = () => client.get("/auth/invites").then((r) => r.data);
export const revokeInvite = (id) => client.delete(`/auth/invites/${id}`).then((r) => r.data);
export const getInvite = (token) => client.get(`/auth/invite/${token}`).then((r) => r.data);
export const acceptInvite = (token, payload) => client.post(`/auth/invite/${token}/accept`, payload).then((r) => r.data);
export const forgotPassword = (email) => client.post("/auth/forgot", { email }).then((r) => r.data);
export const checkResetToken = (token) => client.get(`/auth/reset/${token}`).then((r) => r.data);
export const resetPassword = (payload) => client.post("/auth/reset", payload).then((r) => r.data);
export const lostTwoFA = (mfa_token) => client.post("/auth/2fa/lost", { mfa_token }).then((r) => r.data);
export const twoFAResetStart = (token) => client.post(`/auth/2fa/reset/${token}/start`).then((r) => r.data);
export const twoFAResetConfirm = (token, code) => client.post(`/auth/2fa/reset/${token}/confirm`, { code }).then((r) => r.data);

export const apiError = (e) => {
  const d = e?.response?.data?.detail;
  if (typeof d === "string") return d;
  if (Array.isArray(d)) return d.map((x) => x?.msg || JSON.stringify(x)).join(" ");
  return e?.message || "Something went wrong.";
};


export const getDocTypes = () => client.get("/doc-types").then((r) => r.data);
export const getNextDocNumber = (docType) =>
  client.get("/next-doc-number", { params: { doc_type: docType } }).then((r) => r.data);
export const generateDocument = (payload) => client.post("/generate", payload).then((r) => r.data);
export const listDocuments = () => client.get("/documents").then((r) => r.data);
export const getDocument = (id) => client.get(`/documents/${id}`).then((r) => r.data);
export const createDocument = (payload) => client.post("/documents", payload).then((r) => r.data);
export const updateDocument = (id, payload) => client.put(`/documents/${id}`, payload).then((r) => r.data);
export const deleteDocument = (id) => client.delete(`/documents/${id}`).then((r) => r.data);
export const getVersions = (id) => client.get(`/documents/${id}/versions`).then((r) => r.data);

export const getBrand = () => client.get("/brand").then((r) => r.data);export const updateBrand = (payload) => client.put("/brand", payload).then((r) => r.data);
export const uploadLogo = (formData) =>
  client.post("/brand/logo", formData, { headers: { "Content-Type": "multipart/form-data" } }).then((r) => r.data);
export const deleteLogo = () => client.delete("/brand/logo").then((r) => r.data);
export const logoUrl = () => `${API}/brand/logo`;

export const exportFile = async (kind, payload) => {
  const res = await client.post(`/export/${kind}`, payload, { responseType: "blob" });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : `document.${kind === "docx" ? "docx" : "pdf"}`;
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

// ---- Form Builder (Microsoft Forms) ----
export const generateForm = (payload) => client.post("/forms/generate", payload).then((r) => r.data);
export const exportFormDocx = async (payload) => {
  const res = await client.post("/forms/export/docx", payload, { responseType: "blob" });
  const disposition = res.headers["content-disposition"] || "";
  const match = disposition.match(/filename="?([^"]+)"?/);
  const filename = match ? match[1] : "form_MSForms.docx";
  const url = window.URL.createObjectURL(new Blob([res.data]));
  const a = document.createElement("a");
  a.href = url;
  a.download = filename;
  document.body.appendChild(a);
  a.click();
  a.remove();
  window.URL.revokeObjectURL(url);
};

export default client;
